import React from 'react'
import styles from './Banner.module.scss'
import cx from 'classnames'
import { EAppearAnimation, ETypography } from '@/interfaces'
import Image from 'next/image'
import separatorImg from '@/assets/icons/separator.png'
import Link from 'next/link'

type Props = {
  text: string
  subtext: string
  appear?: boolean
}

const Banner = ({ text, subtext, appear }: Props) => (
  <div
    className={cx(styles.banner, EAppearAnimation.fromBottom, {
      [EAppearAnimation.show]: appear,
    })}
  >
    <div className={styles.textWrapper}>
      <div className={styles.lineLeft}></div>
      <Link href="/ai">
        <span className={cx(ETypography.small, styles.text)}>{text}</span>
      </Link>
      <div className={styles.separatorWrapper}>
        <Image src={separatorImg} layout="responsive"></Image>
      </div>
      <Link href="/ai">
        <span className={cx(ETypography.small, styles.subtext)}>{subtext}</span>
      </Link>
      <div className={styles.lineRight}></div>
    </div>
  </div>
)

export default Banner
